import React from 'react'
import { useNavigate } from 'react-router-dom'
import { RadBox } from './RadBox'
import { RadButton } from './RadButton'

export function RadError ({ heading, message, reset }) {
  const navigate = useNavigate()

  function goHome () {
    reset()
    navigate('/')
  }

  return (
    <RadBox
      className='white'
      textAlign='center'
      padding={{ top: 'xxl' }}
    >
      <RadBox fontWeight='bold' color='inherit' fontSize='display-l'>{heading}</RadBox>
      <RadBox padding={{ bottom: 'xxl' }} color='inherit'>{message}</RadBox>
      <RadButton iconName='undo' onClick={goHome}>Home</RadButton>
    </RadBox>
  )
}
